module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/402.456c7b86.png";